import { useState, useEffect, useMemo, useContext} from "react"
import { getStoryblokApi } from "@storyblok/react"
import { useSpecificAuthors } from "./useStoryblokAuthors"
import { SeriesStoryToObject } from "../helpers/storyHelpers"

function useStoryblokSeries(language) {
  const [series, setSeries] = useState({})

  useEffect(() => {
    if (!series[language]) {
      const storyblokApi = getStoryblokApi()
      storyblokApi.get("cdn/stories", {
        version: process.env.STORYBLOK_API_CONTENT_VERSION,
        filter_query: { component: { in: "series" } },
        language: language,
      }).then(({ data }) => {
        if (data && data.stories && data.stories.length > 0) {
          setSeries({
            language: data.stories.map((s) => {
              return SeriesStoryToObject(s);
            }),
          });
        }
      }).catch((err) => {
        console.error(err)
      })
    }
  }, [language])

  return series[language] ? series[language] : [];
}

function useStoryblokSpecificSeries(uuids, language) {
  const [series, setSeries] = useState({});

  useEffect(() => {

      let uuidlist = uuids.join(",");

      if (uuidlist) {
        const storyblokApi = getStoryblokApi();
        storyblokApi
          .get("cdn/stories", {
            version: process.env.STORYBLOK_API_CONTENT_VERSION,
            content_type: "series",
            language: language,
            by_uuids: uuidlist,
          })
          .then(({ data }) => {
            if (data && data.stories && data.stories.length > 0) {
              const result = [];
              for (let uuid of uuids) {
                const singleSeries = data.stories.find(item => item.uuid === uuid);
                if (singleSeries) {
                  result.push(singleSeries); //ensure they are in order they were requested
                }
              }
              setSeries({
                ...series,
                [language]:
                  result.map((s) => {
                    return SeriesStoryToObject(s);
                  })
                }
              );
            }
          })
          .catch((err) => {
            console.error(err);
          });
        }
    }, [uuids, language]);
  return series && series[language] ? series[language] : [];
}

export { useStoryblokSeries, useStoryblokSpecificSeries }
